import {OrderByQuery, PagingQuery, parseEnum} from "orpyx-web-common";
import {ListOrpyxUserPropertyOrderBy, OrpyxRoleType} from "admins-dashboard/http-clients/index";

export class OrpyxUsersSearchQuery extends OrderByQuery<ListOrpyxUserPropertyOrderBy> {
    /// <summary>
    /// <para>Search users by</para>
    /// <para>- FirstName or LastName</para>
    /// <para>- Pair of FirstName and LastName</para>
    /// </summary>
    term?: string | undefined;

    /// <summary>
    /// <para>Search users with OrpyxRole</para>
    /// </summary>
    orpyxRoleType?: OrpyxRoleType | undefined;

    public static parse(term: string | undefined, orderBy: string | undefined, orderByAsc: string | undefined, orpyxRoleType: string | undefined, offset: string | undefined, count: string | undefined): OrpyxUsersSearchQuery {
        const orderByValue = parseEnum(ListOrpyxUserPropertyOrderBy, orderBy, ListOrpyxUserPropertyOrderBy.OrpyxUserId);

        return new OrpyxUsersSearchQuery
        (
            term,
            orderByValue,
            !!orderByAsc,
            parseEnum(OrpyxRoleType, orpyxRoleType),

            offset ? parseInt(offset) : PagingQuery.DEFAULT_PAGE,
            count ? parseInt(count) : PagingQuery.DEFAULT_COUNT
        );
    }

    constructor(term?: string | undefined, orderBy?: ListOrpyxUserPropertyOrderBy, orderByAsc?: boolean, orpyxRoleType?: OrpyxRoleType | undefined, offset: number | undefined = PagingQuery.DEFAULT_PAGE, count: number | undefined = PagingQuery.DEFAULT_COUNT) {
        super(orderBy, orderByAsc, offset, count);
        this.orpyxRoleType = orpyxRoleType;
        this.term = term;
    }
}

export const toQueryString = (query: OrpyxUsersSearchQuery): string => {
    let str = `offset=${query.offset}&count=${query.count}`;
    if (query.term) {
        str += `&term=${query.term}`;
    }

    if (query.orpyxRoleType) {
        str += `&orpyxRoleType=${query.orpyxRoleType}`;
    }

    if (query.orderBy) {
        str += `&${OrpyxUsersSearchQuery.PARAM_ORDER_BY}=${query.orderBy}`;
    }
    if (query.orderByAsc) {
        str += `&${OrpyxUsersSearchQuery.PARAM_ORDER_BY_ASC}=${query.orderByAsc}`;
    }

    return str;
};
